import styles from '../Responsive.module.scss'

const Mobile = ({ children }) => <div className={styles.mobile}>{children}</div>

export default Mobile
